import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Card, Row, Col, Form } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
// import Header from '../../components/common/Header/Header';
const EligibilityNotifications = (props) => {
  const { onChange, hasEditPermission, onBlur, touched } = props;
  const { values, errors, errorValidation } = props;
  return (
    <>
      <Row className="Payment-details pb-0">
        <Col md={4} lg={4} sm={4} className="padding-0">
          <h3>Notifications</h3>
          <p>
            Specify if email alerts should be sent to members during open
            enrollment, life events, or new hire enrollment based on request,
            approval, or denial.
          </p>
        </Col>
        <Col md={8} lg={8} sm={8} className="setup-form">
          <div className="eligibilityapproval-category">Open Enrollment</div>
          <Row className="pt-2">
            <Col sm={4} md={4} lg={4}>
              <Form.Group id="formGridallowMember">
                <Form.Label for="openEmailReq">Email on Request</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.openEmailReq}
                  id="openEmailReq"
                  onChange={onChange}
                  name="openEmailReq"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="approval-enroll">
              <Form.Group id="formGridallowDependent">
                <Form.Label for="openEmailApproval">
                  Email on Approval
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.openEmailApproval}
                  onChange={onChange}
                  id="openEmailApproval"
                  name="openEmailApproval"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="denail-enroll">
              <Form.Group id="formGridallowMember">
                <Form.Label for="openEmailDenial">Email on Denail</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.openEmailDenial}
                  id="openEmailDenial"
                  onChange={onChange}
                  name="openEmailDenial"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formBasicminAge">
            <Form.Label className="reg-lable" for="minAge">
              Email Address
              <span className="mandatory-field"> *</span>
            </Form.Label>
            <Form.Control
              value={values.openEnrollEmail}
              onChange={onChange}
              // id="minAge"
              className="enroll-email"
              name="openEnrollEmail"
              placeholder="Enter email address to get notified"
              spellCheck="off"
              autoCorrect="off"
              autoComplete="off"
              autoFocus={false}
              onBlur={onBlur}
              isInvalid={errors.openEnrollEmail}
            ></Form.Control>
            <Form.Control.Feedback type="invalid">
              <span role="alert">{errors.openEnrollEmail}</span>
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row className="Payment-details pb-0">
        <Col md={4} lg={4} sm={4} className="padding-0"></Col>
        <Col md={8} lg={8} sm={8} className="setup-form">
          <div className="eligibilityapproval-category">
            New-Hire Enrollment
          </div>
          <Row className="pt-2">
            <Col sm={4} md={4} lg={4}>
              <Form.Group id="formGridallowMember">
                <Form.Label for="newHireEmailReq">Email on Request</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.newHireEmailReq}
                  id="newHireEmailReq"
                  onChange={onChange}
                  name="newHireEmailReq"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="approval-enroll">
              <Form.Group id="formGridallowDependent">
                <Form.Label for="newHireEmailApproval">
                  Email on Approval
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.newHireEmailApproval}
                  onChange={onChange}
                  id="newHireEmailApproval"
                  name="newHireEmailApproval"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="denail-enroll">
              <Form.Group id="formGridallowMember">
                <Form.Label for="newHireEmailDenial">
                  Email on Denail
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.newHireEmailDenial}
                  id="newHireEmailDenial"
                  onChange={onChange}
                  name="newHireEmailDenial"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formBasicminAge">
            <Form.Label className="reg-lable" for="minAge">
              Email Address
              <span className="mandatory-field"> *</span>
            </Form.Label>
            <Form.Control
              className="enroll-email"
              value={values.newHireEmail}
              onChange={onChange}
              // id="minAge"
              name="newHireEmail"
              placeholder="Enter email address to get notified"
              spellCheck="off"
              autoCorrect="off"
              autoComplete="off"
              autoFocus={false}
              onBlur={onBlur}
              isInvalid={errors.newHireEmail}
            ></Form.Control>
            <Form.Control.Feedback type="invalid">
              <span role="alert">{errors.newHireEmail}</span>
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row className="Payment-details pb-0">
        <Col md={4} lg={4} sm={4} className="padding-0"></Col>
        <Col md={8} lg={8} sm={8} className="setup-form">
          <div className="eligibilityapproval-category">
            Life-Event Enrollment
          </div>
          <Row className="pt-2">
            <Col sm={4} md={4} lg={4}>
              <Form.Group id="formGridallowMember">
                <Form.Label for="lifeEventEmailReq">
                  Email on Request
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.lifeEventEmailReq}
                  id="lifeEventEmailReq"
                  onChange={onChange}
                  name="lifeEventEmailReq"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="approval-enroll">
              <Form.Group id="formGridallowDependent">
                <Form.Label for="lifeEventEmailApproval">
                  Email on Approval
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.lifeEventEmailApproval}
                  onChange={onChange}
                  id="lifeEventEmailApproval"
                  name="lifeEventEmailApproval"
                />
              </Form.Group>
            </Col>
            <Col sm={4} md={4} lg={4} className="denail-enroll">
              <Form.Group id="formGridallowMember">
                <Form.Label for="lifeEventEmailDenial">
                  Email on Denail
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={values.lifeEventEmailDenial}
                  id="lifeEventEmailDenial"
                  onChange={onChange}
                  name="lifeEventEmailDenial"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formBasicminAge">
            <Form.Label className="reg-lable" for="minAge">
              Email Address
              <span className="mandatory-field"> *</span>
            </Form.Label>
            <Form.Control
              className="enroll-email"
              value={values.lifeEventEmail}
              onChange={onChange}
              name="lifeEventEmail"
              placeholder="Enter email address to get notified"
              spellCheck="off"
              autoCorrect="off"
              autoComplete="off"
              autoFocus={false}
              onBlur={onBlur}
              isInvalid={errors.lifeEventEmail}
            ></Form.Control>
            <Form.Control.Feedback type="invalid">
              <span role="alert">{errors.lifeEventEmail}</span>
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
export default EligibilityNotifications;
